<template>
  <v-col cols="12" sm="6" md="4" lg="3" class="media-item" @click.stop="$emit('select')">
    <v-card role="button" :class="[{ 'elevation-10' : dataset.active }, { 'elevation-1' : !dataset.active }, 'accent']">
      <v-img height="250px" :src="dataset.path">
        <v-btn v-if="deleteable" fab dark small color="red darken-2 btn-remove" @click.stop="$emit('delete', dataset)">
          <v-icon dark>mdi-delete</v-icon>
        </v-btn>
        <v-row dense class="fill-height white--text">
          <v-col cols="12">
            <v-card-title>
              <p class="truncate-text" v-html="dataset.name"></p>
            </v-card-title>
            <v-slide-y-transition v-if="functions.isNotImage(dataset.type)">
              <v-icon v-html="functions.getMediaIcon(dataset.type)" ripple class="pa-1 text-center icon-file"></v-icon>
            </v-slide-y-transition>
            <v-slide-y-transition v-if="selectable">
              <v-icon ripple class="text-h4 pa-1 text-center white--text icon-selected" v-show="dataset.active">check</v-icon>
            </v-slide-y-transition>
            <v-spacer></v-spacer>
            <v-card-actions class="px-2 white--text">
              <v-icon class="white--text" v-html="functions.getMediaIcon(dataset.type)"></v-icon>
              <v-spacer></v-spacer>
              <span v-html="dataset.type"></span>
              <span v-html="functions.formatBytes(dataset.size)"></span>
            </v-card-actions>
          </v-col>
        </v-row>
      </v-img>
    </v-card>
  </v-col>
</template>

<script>
import functions from '@/components/Utils/Class/functions.js'

export default {
  name: 'mediaItem',
  components: {},
  props: {
    // Define se o item vai mostrar um botão com evento de
    // delete ou não
    deleteable: {
      type: Boolean,
      required: false,
      default: false
    },
    // Define se o item de mídia vai ser selecionável ou não
    selectable: {
      type: Boolean,
      required: false,
      default: false
    },
    // Objeto que representa a mídia/arquivo a ser mostrado
    dataset: {
      type: Object,
      required: true,
      default: function () {
        return {
          thumbnail: 'thumbnail',
          name: 'nome',
          type: 'data/file',
          size: 0,
          active: false,
          id: 0
        }
      }
    }
  },
  data: function () {
    return {
      // Src customizado para imagens, que representa seus
      // dataimage
      customSrc: '',
      // Funções úteis
      functions: functions
    }
  },
  methods: {}
}
</script>

<style scoped>
.media-item .card .card__title, .media-item .card .card__actions {
  background-color: rgba(44, 44, 44, 0.4);
}

.media-item .card .icon-selected {
  text-shadow: 1px 1px 10px rgba(150, 150, 150, 1);
  z-index: 1;
}

.truncate-text {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 200px;
  margin-bottom: 0px;
}

.icon-file {
  font-size: 110px;
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
}

.media-item {
  width: 250px;
}

.btn-remove {
  position: absolute;
  right: 10px;
}
</style>
